import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';


export const defaultOptions = {
    rerenderOn: ['languageChanged', 'loaded', 'added', 'removed']
};
const translations = {};

// Domyślne wartości kontekstu
const defaultContextValue = {
    t: (id) => id, // Funkcja domyślna - zwraca ID, jeśli tłumaczenie nie istnieje
    i18n: {
        language: 'hr', // Domyślny język
        changeLanguage: () => {}, // Placeholder dla funkcji zmiany języka
    },
};

// Tworzenie kontekstu
export const I18nContext = createContext(defaultContextValue);

// Komponent Provider dostarczający kontekst
export const I18nProvider = ({ children, initialLanguage = 'hr' }) => {
    const [language, setLanguage] = useState(initialLanguage);

    // Funkcja tłumacząca
    const t = (id, fallback = id) => {
        return translations[language]?.[id] || fallback;
    };

    // Wartość kontekstu z memoizacją
    const contextValue = useMemo(() => ({
        t,
        i18n: {
            language,
            changeLanguage: (newLang) => setLanguage(newLang),
        },
    }), [language]);

    return (
        <I18nContext.Provider value={contextValue}>
            {children}
        </I18nContext.Provider>
    );
};

// PropTypes dla I18nProvider
I18nProvider.propTypes = {
    children: PropTypes.node.isRequired,
    initialLanguage: PropTypes.string,
    customTranslations: PropTypes.object,
};

// Domyślne wartości propsów
I18nProvider.defaultProps = {
    initialLanguage: 'hr',
    customTranslations: translations,
};